import styles from './Star.module.scss';

type StarProps = {
  number: number;
  onClick: () => void;
  chosen: number;
  hoveredNumber: number | null;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
};

export function Star({
  number,
  onClick,
  chosen,
  hoveredNumber,
  onMouseEnter,
  onMouseLeave,
}: StarProps) {
  const isActive =
    Number(number) <= Number(chosen) ||
    (hoveredNumber && number <= hoveredNumber);

  if (isActive)
    return (
      <img
        src="/svg/star.svg"
        alt="star"
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        className={styles.star}
      />
    );

  return (
    <img
      src="/svg/star-gray.svg"
      alt="star"
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      className={styles.star}
    />
  );
}
